import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from "@angular/core";

const SUPPORTS_INTL_API = typeof Intl !== 'undefined';

@Injectable()
export class MyDateAdapter extends NativeDateAdapter {
  useUtcForDisplay = true;

  resultDate: string = '';

  getFirstDayOfWeek(): number {
    return 1;
  }

  parse(value: any): Date | null {
    if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
      const str = value.split('/');

      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);

      try {
        return this.createDate(year, month, date);
      } catch (error) {
        return null;
      }
    }
    if (value.length == 8 || value.length == 6) {
      return this.formatDate(value);
    } else {
      return null;
    }
  }

  private formatDate(input: string): Date | null {
    this.resultDate += input.substring(0, 2) + "/";
    this.resultDate += input.substring(2, 4) + "/";
    this.resultDate += input.substring(4);

    const str = this.resultDate.split('/');
    this.resultDate = '';

    const yearPart = str[2];
    let year = Number(yearPart);
    const month = Number(str[1]) - 1;
    const date = Number(str[0]);

    // DDMMYY (año de 2 cifras) — expandir con pivote tipo tarjeta de crédito:
    // 00-79 → 20XX, 80-99 → 19XX
    if (yearPart.length === 2) {
      year += year <= 79 ? 2000 : 1900;
    }

    try {
      return this.createDate(year, month, date);
    } catch (error) {
      return null;
    }
  }

  // to be removed when mmalerba merge the mods in the next beta
  format(date: Date, displayFormat: Object): string {
    if (SUPPORTS_INTL_API) {
      if (this.useUtcForDisplay) {
        date = new Date(Date.UTC(
          date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(),
          date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        displayFormat = Object.assign({}, displayFormat, { timeZone: 'utc' });
      }

      const dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
      return dtf.format(date).replace(/[\u200e\u200f]/g, '');
    }
  }

  createDate(year: number, month: number, date: number): Date {
    const localDate = super.createDate(year, month, date);
    //Pasamos de minutos a milisegundos
    let offset = localDate.getTimezoneOffset() * 60000;
    //Aplica a zonas horarias negativas UTC
    if (Math.sign(offset) == 1) {
      offset = -Math.abs(offset)
    }

    return new Date(localDate.getTime() - offset);
  }
}
